import { useCallback, useState } from "react";
import { TaxInformationDetailsCard } from "@/components/profile-cards";
import type { IInspectorW9Form } from "@/types/users-inspectors";
import { useBoolean } from "@/ui-kit";
import EditModal from "./EditModal";

type IProps = {
  userId: number;
  w9Form: IInspectorW9Form;
};

export const TaxInformationDetails = ({ userId, w9Form }: IProps) => {
  const [values, setValues] = useState<IInspectorW9Form>(w9Form);

  const updateValues = useCallback((v: IInspectorW9Form) => {
    setValues(v);
  }, []);

  const {
    value: showEditUserModal,
    setTrue: openEditUserModal,
    setFalse: dismissEditUserModal,
  } = useBoolean(false);

  return (
    <>
      <TaxInformationDetailsCard w9Form={values} onEdit={openEditUserModal} />
      {showEditUserModal && (
        <EditModal
          userId={userId}
          w9form={values}
          onSave={updateValues}
          onDismiss={dismissEditUserModal}
        />
      )}
    </>
  );
};
